import { render, staticRenderFns } from "./CostosProveedores.vue?vue&type=template&id=2acf41b1&"
import script from "./CostosProveedores.vue?vue&type=script&lang=js&"
export * from "./CostosProveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports